import { IoWarning } from "react-icons/io5";

import { cn } from "./cn";

/** A plain inline error banner shown in the transcript when a step fails. */
export function ErrorBanner({
  message,
  className,
}: {
  message: string;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2.5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600",
        className
      )}
    >
      <IoWarning className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
